'use strict';
import * as $j_app$002ecomponents$002einstances$0024package$0024$0024anon$00244 from "./app.components.instances$package$$anon$4.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_components_instances$package$$anon$3(x$1$10) {
  this.ahr = null;
  this.ahr = x$1$10;
}
export { $c_Lapp_components_instances$package$$anon$3 as $c_Lapp_components_instances$package$$anon$3 };
$p = $c_Lapp_components_instances$package$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_components_instances$package$$anon$3;
/** @constructor */
function $h_Lapp_components_instances$package$$anon$3() {
}
export { $h_Lapp_components_instances$package$$anon$3 as $h_Lapp_components_instances$package$$anon$3 };
$h_Lapp_components_instances$package$$anon$3.prototype = $p;
$p.bSK = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().fe(new $j_app$002ecomponents$002einstances$0024package$0024$0024anon$00244.$c_Lapp_components_instances$package$$anon$4(this));
});
$p.bVf = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().fe(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
    var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if (((x === null) ? (x$1 === null) : (x === x$1))) {
      return "Results per page";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().ay()).bD(this.ahr));
});
var $d_Lapp_components_instances$package$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_components_instances$package$$anon$3, "app.components.instances$package$$anon$3", ({
  z0: 1,
  VG: 1
}));
export { $d_Lapp_components_instances$package$$anon$3 as $d_Lapp_components_instances$package$$anon$3 };
//# sourceMappingURL=app.components.instances$package$$anon$3.js.map
